<template>
    <div class="slinkContainerComp">
        <div class="slinkContainer posRel" @click="openDetail">
            <div class="columns">
                <div class="column">
                    <div class="left20 is-size-4 top5"><b>:hello</b></div>
                </div>
                <div class="column">
                    <div class="is-size-5 top5"><b>SlinkPage: </b></div>
                </div>
                <div class="column">
                    <div class="slinkContainerDisplayUrl top5 is-size-6">https://thelongulr.com/goes/here/home/asdfadsafda/adsfalfajsfadsfa/asdfafd</div>
                </div>
                <i class="fa fa-qrcode has-text-dark is-size-5"></i>
            </div>
            
        </div>
      

        

        <div>

        </div>
    </div>
</template>

<script>
export default {
    components: {
        
    },

    data: function(){
        return {
            
        }
    },

    methods: {
       
    }
}

</script>


// WEBPACK FOOTER //
// src/components/SlinkContainer.vue